// todo: remove deprecated objects from other files, remove `export`, and then remove deprecation comment
const nullOperatorLabels = {
  isNull: 'Is Null',
  isNotNull: 'Is Not Null',
};
const emptyOperatorLabels ={
  textEmpty: 'Is Empty',
  textNotEmpty: 'Is Not Empty',
}
/**
 * @param includeNull bool
 * @param includeEmpty bool
 * @return Object containing unary operators in the format {operatorName: 'Label for <select>'}
 */
export function getUnaryOperatorLabels(includeNull = true, includeEmpty = false) {
  return {...(includeNull && nullOperatorLabels), ...(includeEmpty && emptyOperatorLabels)};
}
/** @deprecated Can be used inside operators.js, but otherwise should be replaced with label function or function to check type **/
export const unaryOperators = Object.keys(getUnaryOperatorLabels(true, true));

export const numericOperatorLabels = {
  lt: '<',
  lte: '≤',
  gt: '>',
  gte: '≥',
  eq: '=',
  neq: '≠',
};
const numericOperators = Object.keys(numericOperatorLabels);

export const textOperatorLabels = {
  contains: 'Contains',
  doesNotContain: 'Does Not Contain',
  startsWith: 'Starts With',
  endsWith: 'Ends With',
  textEquals: 'Equals',
  textDoesNotEqual: 'Does Not Equal',
};
const textOperators = Object.keys(textOperatorLabels);

export const daysOfWeek = {
  0: { name: 'Sunday' },
  1: { name: 'Monday' },
  2: { name: 'Tuesday' },
  3: { name: 'Wednesday' },
  4: { name: 'Thursday' },
  5: { name: 'Friday' },
  6: { name: 'Saturday' },
};
export const dateOperatorLabels = {
  dateIsBefore: 'Is Before',
  dateIsAfter: 'Is After',
  dateEquals: 'Is Same Day As',
  dateIsOneOf: 'Is Day Of Week',
};
const dateOperators = Object.keys(dateOperatorLabels);

/** @deprecated Confusing—We take this and negate it in operatorIsNumeric instead of checking against operators we know are numeric. What happens when the operator is null? **/
export const nonNumericOperators = [
  'isOneOf',
].concat(dateOperators).concat(unaryOperators).concat(textOperators);

export function operatorIsNumeric(operator) {
  return numericOperators.includes(operator);
}

export function operatorIsText(operator) {
  return textOperators.includes(operator);
}

export function operatorIsDate(operator) {
  return dateOperators.includes(operator);
}

export function operatorIsUnary(operator) {
  return unaryOperators.includes(operator);
}

export function getComparatorType(operator) {
  switch(true) {
    case operator === 'isOneOf':
    case operator === 'dateIsOneOf':
      return 'multiple_choice';
    case operatorIsDate(operator):
      return 'variable';
      case operatorIsNumeric(operator):
        return 'amount';
      case operatorIsText(operator):
        return 'text';
      case operatorIsUnary(operator):
      default:
        return '';
  }
}